export default {
  UPDATE_LAB_MODE: 'labMode/UPDATE_LAB_MODE'
};
